import { render, staticRenderFns } from "./Representation.vue?vue&type=template&id=494fda5c&scoped=true&"
import script from "./Representation.vue?vue&type=script&lang=js&"
export * from "./Representation.vue?vue&type=script&lang=js&"
import style0 from "./Representation.vue?vue&type=style&index=0&id=494fda5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494fda5c",
  null
  
)

export default component.exports